<template>
<div></div>
</template>

<script>
export default {
  name: "AccountProfileView"
}
</script>

<style scoped>

</style>